import {HTTP_INTERCEPTORS, HttpInterceptor, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {EnvironmentProviders, makeEnvironmentProviders, Type} from '@angular/core';
import {HttpLoadingInterceptor} from '@aviary/interceptors/http-loading.interceptor';
import {HttpErrorInterceptor} from '@aviary/interceptors/http-error.interceptor';

export function provideAviaryHttp<RouteNameType extends string>(jwtTokenInterceptor: Type<HttpInterceptor>): EnvironmentProviders {
  return makeEnvironmentProviders([
    {provide: HTTP_INTERCEPTORS, useClass: HttpLoadingInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor<RouteNameType>, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: jwtTokenInterceptor, multi: true},
    provideHttpClient(withInterceptorsFromDi())
  ]);
}
